// A hub page: its heading, then its body. Until a page's own task builds it (E12-S2 onwards) the
// body is the empty state the mockups draw for a panel with nothing in it yet (mockups/kit/surface.css
// .wp-conv__empty and .wp-empty): an icon, a line in the text colour, a quieter line beneath.
import { Icon, type IconName } from "@waypoint/surface";
import type { ReactNode } from "react";

export function Page({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <section aria-labelledby="page-title" className="grid gap-5">
      <h1 id="page-title" className="text-22 leading-tight font-semibold text-wp-text">
        {title}
      </h1>
      {children}
    </section>
  );
}

export function EmptyState({
  icon,
  title,
  line,
  children,
}: {
  icon: IconName;
  title: string;
  line?: string;
  children?: ReactNode;
}) {
  return (
    <div className="grid justify-items-center gap-1.5 rounded-12 border border-dashed border-wp-line-strong px-3 py-7 text-center text-13 text-wp-text-3">
      <Icon name={icon} size={20} />
      <p className="mt-2 text-15 font-semibold text-wp-text">{title}</p>
      {line === undefined ? null : <p>{line}</p>}
      {children}
    </div>
  );
}
